import Select from "react-select";
import { designAreaLabel } from "../../../../utils/design-areas";

type DesignFile = {
  id: string;
  author: string;
  campaign: string;
  created_at: string;
  configurable: boolean;
  original_file_name: string;
  file_name: string;
  file_url: string;
  design_colors: string[];
};

export function AssignDesignAreas({
  areas,
  designOptions,
  selectDesign,
}: {
  areas: string[];
  designOptions: { label: string; value: DesignFile }[];
  selectDesign: ({ area, design }: { area: string; design: any }) => void;
}) {
  if (!areas.length) {
    return (
      <div>
        <div className="flex-1 min-w-0 mt-4">
          <p className="italic">No Products Selected</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex-1 min-w-0 mt-4">
        <p>Apply designs to areas</p>
      </div>
      <div className="mt-1 space-y-8">
        {areas.map(function (area) {
          return (
            <div key={area}>
              <p>{designAreaLabel(area)}</p>
              <p className="text-xs text-gray-500">{area}</p>
              <Select
                name="design_assigment"
                isClearable
                options={designOptions}
                onChange={(design) => selectDesign({ area, design })}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
